import o from "../../share/apeiron/ApeironTextField.js";
import { t as e } from "i18next";
import { jsx as n } from "react/jsx-runtime";
const t = 6, p = new RegExp(`^[0-9]{${t},${t}}$`), u = (r) => /* @__PURE__ */ n(o, {
  ...r,
  rules: {
    required: !0,
    pattern: p
  },
  label: e("account_setting.input_otp_label"),
  helperText: e("account_setting.otp_error", {
    length: t
  })
});
export {
  u as default
};
//# sourceMappingURL=OTPCodeTextField.js.map
